import { saveProjectBatchSize } from 'features/BillOfMaterials/store/asyncActions/saveProjectBatchSize'
import { ProjectTextField } from 'features/BillOfMaterials/store/components/ProjectTextField'
import { projectQuantitySelector } from 'features/BillOfMaterials/store/selectors/projectQuantitySelector'
import { valueGreaterThanZero } from 'features/BillOfMaterials/Validations/valueGreaterThanZero'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { ProjectEditableStateSelector } from '../store/selectors/ProjectEditableStateSelector'

export function ProjectBatchSizeInput(props: { textFieldClassName?: string }) {
  const projectIsEditable = useAppSelector(ProjectEditableStateSelector)
  const { t } = useTranslation()

  return (
    <ProjectTextField
      valueSelector={projectQuantitySelector}
      saveAction={saveProjectBatchSize}
      disableShowHelpText
      textFieldProps={{
        label: t('project:batch-size'),
        type: 'number',
        required: true,
        className: props.textFieldClassName,
        slotProps: {
          input: {
            readOnly: !projectIsEditable,
            disabled: !projectIsEditable,
            disableUnderline: !projectIsEditable,
          },
          htmlInput: {
            min: 1,
            max: 1_000_000,
            readOnly: !projectIsEditable,
            disabled: !projectIsEditable,
          },
        },
      }}
      validation={(value) => {
        var greaterThanZeroValidation = valueGreaterThanZero(value)

        if (!greaterThanZeroValidation.isValid) {
          return {
            isValid: false,
            errorMessage: t('common:min-value', { minValue: 1 }),
          }
        }

        if (parseFloat(value.toString()) > 1_000_000) {
          return {
            isValid: false,
            errorMessage: t('common:max-value', { maxValue: 1_000_000 }),
          }
        }

        return { isValid: true }
      }}
    />
  )
}
